import { ReactNode } from "react";

import { NextSeo } from "next-seo";
import Head from "next/head";
import { useRouter } from "next/router";

export interface Props {
  title: string;
  description: string;
  enableCrawlerIndex?: boolean;
  pageUrl?: string; //Canonical path for SEO and indexing purposes.
  index?: boolean | null;
  follow?: boolean | null;
  children?: ReactNode;
}

/**
 * Use this component on any public `/pages` that we need for SEO purpose
 */
export default function SEO({
  title = "Notabene.id",
  description = "Crypto regulations made simple. Notabene is a blockchain-focused compliance platform for financial institutions",
  pageUrl,
  children, //put here anything extra for inside the <Head/>
  enableCrawlerIndex = false,
}: Props) {
  const router = useRouter();

  pageUrl = pageUrl ? pageUrl : (`${process.env.service.url}${router.asPath}` as string);

  return (
    <>
      <Head>
        {/* https://search.google.com/u/2/search-console */}
        <meta name="google-site-verification" content="UfwW2R912su3cA5CprguFJnatEQRg4N54yjqSkVMTpg" />
        {children}
      </Head>

      <NextSeo
        title={title}
        description={description}
        canonical={pageUrl || "error with pageUrl"}
        noindex={!enableCrawlerIndex}
        nofollow={!enableCrawlerIndex}
        openGraph={{
          url: pageUrl || "error with pageUrl",
          title: title,
          description: description,
          images: [
            {
              url: `https://assets-global.website-files.com/5e68f0772de982756aa8c1a4/6042776f9ab89e6f464ef022_Notabene.png`,
              width: 800,
              height: 600,
              alt: "Notabene Logo",
              type: "image/png",
            },
            {
              url: `/assets/notabene_image.png`,
              width: 800,
              height: 600,
              alt: "Notabene Logo",
              type: "image/png",
            },
          ],
          site_name: "Notabene.id",
        }}
        additionalLinkTags={[
          {
            rel: "icon",
            href: "/favicon-black.ico",
          },
          {
            rel: "apple-touch-icon",
            href: "/apple-touch-icon.png",
            sizes: "180x180",
          },
          {
            rel: "manifest",
            href: "/site.webmanifest",
          },
        ]}
        twitter={{
          handle: "@notabene_id",
          site: "@notabene_id",
          cardType: "summary_large_image",
        }}
      />
    </>
  );
}
